module.exports = __webpack_public_path__ + "img/logo.908953b2.png";